import React from 'react';

const ObstacleAvoidanceGame: React.FC = () => {
  return (
   <div className="text-justify py-4">
      <p className="mb-4">
        Ajang <b>Indonesia Innovative Technology Challenge (IITC) 2024</b> menghadirkan kategori unik yang memadukan teknologi, kreativitas, dan strategi dalam robotika yaitu <b>Obstacle Avoidance Driving Game</b>. Kompetisi ini dirancang untuk siswa SMP dan SMA agar dapat memprogram robot pintar yang mampu melewati rintangan secara otomatis di lintasan khusus.
      </p>

      <h2 className="text-2xl font-bold mb-4 mt-6">Apa Itu Obstacle Avoidance Driving Game?</h2>
      <p className="mb-4">
        Kompetisi ini mengharuskan peserta merancang dan memprogram robot agar mampu:
      </p>
      
      <ol className="list-decimal pl-6 mb-6 space-y-2">
        <li>Menghindari rintangan di lintasan.</li>
        <li>Mencapai garis finish dalam waktu tercepat.</li>
      </ol>

      <h2 className="text-2xl font-bold mb-4 mt-6">Pelajaran Berharga bagi Peserta</h2>
      <p className="mb-4">
        Kompetisi ini bukan sekadar adu robot, tetapi juga menjadi ajang pembelajaran teknologi:
      </p>

      <ol className="list-decimal pl-6 mb-6 space-y-4">
        <li>
          <p><strong>Pemrograman</strong></p>
          <ul className="list-[circle] pl-6 mt-2 space-y-1">
            <li>Peserta belajar menggunakan algoritma logika seperti pathfinding dan collision avoidance menjadi andalan banyak tim.</li>
          </ul>
        </li>
        <li>
          <p><strong>Kerja Tim dan Problem Solving</strong></p>
          <ul className="list-[circle] pl-6 mt-2 space-y-1">
            <li>Kompetisi ini mengharuskan peserta bekerja sama untuk memecahkan masalah teknis dan strategis</li>
          </ul>
        </li>
        <li>
          <p><strong>Menghadapi Tantangan dengan Kreativitas</strong></p>
          <ul className="list-[circle] pl-6 mt-2 space-y-1">
            <li>Peserta dituntut untuk berpikir kreatif dalam menyiasati rintangan yang tidak selalu bisa diatasi dengan cara konvensional.</li>
          </ul>
        </li>
      </ol>

      <h2 className="text-2xl font-bold mb-4 mt-6">Menumbuhkan Generasi Cerdas Teknologi</h2>
      <p className="mb-6">
        Kategori <b>Obstacle Avoidance Driving Game</b> di IITC 2024 menjadi bukti bahwa siswa Indonesia memiliki potensi besar dalam teknologi dan robotika. Kompetisi ini tidak hanya mengasah keterampilan teknis, tetapi juga menanamkan semangat pantang menyerah dan kerja keras pada peserta.
      </p>

      <h2 className="text-2xl font-bold mb-4 mt-6">Jelajahi Keseruan IITC 2024</h2>
      <p className="mb-4">
        Untuk informasi lebih lanjut tentang kategori lain dan detail program, kunjungi:
      </p>
      <p className="mb-6">
        <a href="https://iitchallenge.com/iit-program" target='_blank' className="underline font-semibold text-defaultBlue hover:text-blue-800 transition-colors">iitchallenge.com/iit-program</a>
      </p>
      <p className="font-bold">
        Mari dukung generasi muda untuk terus belajar, berinovasi, dan mengembangkan teknologi untuk masa depan!
      </p>
    </div>
  );
};

export default ObstacleAvoidanceGame;